import React from 'react';
import cx from 'classnames';

import { getTailwindColor, scaleImage } from '@trqk/utils';

const iconId = 'music-note-plus';

const originalDimensions = {
    width: 24,
    height: 24,
};

// This uses the SVG from: stockholm-icon-set/Media/Add-music.svg

export const IconMusicNotePlus = (props: IconProps): JSX.Element => {
    const fillColor = props?.fillColor ?? 'black';
    const fill = getTailwindColor(fillColor);
    const { height, width } = scaleImage(originalDimensions, props);
    const { addClasses } = props;

    return (
        <svg
            aria-labelledby={iconId}
            className={cx(addClasses)}
            height={height}
            viewBox={`0 0 ${originalDimensions.width} ${originalDimensions.height}`}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title id={iconId}>Music Note Plus Icon</title>
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h24v24H0z" />
                <path
                    d="M8.979 18.8C8.8 20.04 7.535 21 6 21c-1.657 0-3-1.12-3-2.5S4.343 16 6 16c.35 0 .687.05 1 .142V5.932c0-.513.32-.966.79-1.12l5.75-1.758c.724-.236 1.46.328 1.46 1.12v1.758c0 .586-.549.96-1 1.068-.65.155-2.316.488-5 1v10.551c0 .09-.007.173-.021.25z"
                    fill={fill}
                    fillRule="nonzero"
                />
                <path
                    d="M16 13v-2a1 1 0 012 0v2h2a1 1 0 010 2h-2v2a1 1 0 01-2 0v-2h-2a1 1 0 010-2h2z"
                    fill={fill}
                    opacity=".3"
                />
            </g>
        </svg>
    );
};
